import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import _isNil from 'lodash/isNil';
export function getMenuProps(vertical) {
  var menuProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (vertical) {
    return _objectSpread(_objectSpread({
      fluid: true,
      tabular: true
    }, menuProps), {}, {
      vertical: true
    });
  }
  return _objectSpread({
    attached: true,
    tabular: true
  }, menuProps);
}
export function getGridProps() {
  var gridProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var vertical = arguments.length > 1 ? arguments[1] : undefined;
  var fullWidthVertical = arguments.length > 2 ? arguments[2] : undefined;
  var activeIndex = arguments.length > 3 ? arguments[3] : undefined;
  if (!vertical) {
    return {};
  }
  if (fullWidthVertical && _isNil(activeIndex)) {
    return {
      tabWidth: 16,
      paneWidth: 0
    };
  }
  return gridProps;
}